import { render, staticRenderFns } from "./CommentContentPost.vue?vue&type=template&id=1d4706fa&scoped=true"
import script from "./CommentContentPost.vue?vue&type=script&lang=js"
export * from "./CommentContentPost.vue?vue&type=script&lang=js"
import style0 from "./CommentContentPost.vue?vue&type=style&index=0&id=1d4706fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4706fa",
  null
  
)

export default component.exports